<template>

    <section class="flex flex-col bg-white py-8 rounded-lg my-8 shadow">

        <div class="flex flex-col lg:flex-row items-center mb-8 px-8">

            <div class="text-3xl font-nexa text-blue mb-8 lg:mb-0"
                 style="line-height: 15px;">
                {{ __('Vacation') }}
            </div>


            <button class="border border-darker-blue font-bold text-black py-2 px-4 rounded-full xl:ml-auto select-none text-sm leading-normal xl:text-base xl:leading-[24px]"
                v-if="! is_company_defaults"
                @click="reset_to_company_defaults">
                {{ __('Reset to company defaults') }}
            </button>

        </div>


        <div class="grid w-full overflow-x-scroll"
             :style="`
                grid-template-rows: 40px 1px 10px repeat(${ vacations.length }, 60px);
            `"
            id="vacation_layout">

            <div class="hidden lg:block pl-8 text-gray-400 text-sm flex items-center">{{ __('From date') }}</div>

            <div class="hidden lg:block text-gray-400 text-sm flex items-center"></div>

            <div class="hidden lg:block text-gray-400 text-sm flex items-center">{{ __('To date')}}</div>

            <div class="hidden lg:block text-gray-400 text-sm flex items-center"></div>


            <div class="hidden lg:block border-t border-gray-200"></div>

            <div class="hidden lg:block border-t border-gray-200"></div>

            <div class="hidden lg:block border-t border-gray-200"></div>

            <div class="hidden lg:block border-t border-gray-200"></div>


            <div class="hidden lg:block "></div>

            <div class="hidden lg:block "></div>

            <div class="hidden lg:block "></div>

            <div class="hidden lg:block "></div>


            <template v-for="vacation of vacations"
                :key="vacation.id">

                <div class="pl-8 flex items-center mb-4 lg:mb-0 lg:mt-0">

                    <DateTimePicker class=""
                        :language="$page.props.locale"
                        :value="vacation.start_at"
                        :min_date="vacation.start_at < moment.format() ? vacation.start_at : 'today'"
                        @new_date="(value) => handle_change_date(value,vacation,'start_at')" />

                </div>


                <div class="flex justify-start pl-8 lg:pl-0 lg:justify-center items-center mb-4 lg:mb-0">

                    <font-awesome-icon class=""
                        :icon="[ 'fas', 'arrow-right' ]"
                        size="lg">
                    </font-awesome-icon>

                </div>


                <div class="pl-8 lg:pl-0 flex items-center mb-4 lg:mb-0">

                    <DateTimePicker class=""
                        :language="$page.props.locale"
                        :value="vacation.end_at"
                        :min_date="vacation.start_at"
                        @new_date="(value) => handle_change_date(value,vacation,'end_at')"/>

                </div>


                <div class="flex items-start lg:items-center pl-8 mb-16 lg:mb-0 lg:px-4">

                    <button class="px-3 bg-blue hover:bg-red rounded-md flex items-center"
                        style="width: auto; height: 36px;"
                        @click="remove_vacation(vacation)">

                        <font-awesome-icon class="text-white mr-3"
                            :icon="[ 'fas', 'trash' ]"
                            size="sm"
                        />

                        <div class="text-white">{{ __('Delete')}}</div>

                    </button>

                </div>

            </template>


            <button class="rounded text-white flex items-center px-3 cursor-pointer mr-5 ml-8 mt-5"
                style="background: linear-gradient(180deg, #3E6598 0%, #14325A 100%); width:95px; height:35px;"
                @click="add_vacation">

                <span class="font-bold text-sm">{{ __('Add') }}</span>

                <font-awesome-icon class="text-white ml-auto"
                    :icon="[ 'fas', 'plus' ]"
                    size="sm">
                </font-awesome-icon>

            </button>

        </div>

    </section>

</template>

<script>
import {defineComponent} from "vue";
import DateTimePicker from "../Components/DateTimePicker";

export default defineComponent({

    components: {
        DateTimePicker
    },


    props: {
        vacations: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        start_at: '2021-10-01 00:00:00.00000Z',
                        end_at: '2021-10-11 00:00:00.00000Z',
                    },
                    {
                        id: 2,
                        start_at: '2021-11-01 00:00:00.00000Z',
                        end_at: '2021-11-11 00:00:00.00000Z',
                    }
                ];
            }
        },
        is_company_defaults: {
            type: Boolean,
            default: false
        }
    },


    computed: {

        moment() {

            return moment();

        }

    },


    methods: {

        add_vacation(){

            this.$inertia.post(
                this.route('notifications.create_vacation',{
                    is_company_defaults: this.is_company_defaults
                }),
                {
                    start_at: moment(),
                    end_at: moment().add(1, 'week')
                },
                {
                    preserveScroll: true,
                    onError: (error) => {

                        console.error(error);

                        this.$inertia.message('Problem');

                    },
                    onSuccess: () => {

                        this.$inertia.reload({
                            only: [ 'vacations' ]
                        });

                    }
                }
            );

        },


        handle_change_date(value,vacation,type) {                                                   let debug_id = Debug.init_method('handle_change_date');
                                                                                                    Debug.log(debug_id,185,{value,vacation,type});
            this.$inertia.patch(
                this.route('notifications.update_vacation',{
                    notification_vacation: vacation.id,
                    is_company_defaults: this.is_company_defaults
                }),
                {
                    type,
                    value
                },
                {
                    preserveScroll: true,
                    onError: (error) => {

                        console.error(error);

                        this.$inertia.message('Problem');

                    },
                    onSuccess: () => {

                        this.$inertia.reload({
                            only: [ 'vacations' ]
                        });

                    }
                }
            );

        },


        remove_vacation(vacation) {

            this.$inertia.delete(
                this.route('notifications.delete_vacation',{
                    notification_vacation: vacation.id,
                    is_company_defaults: this.is_company_defaults
                }),
                {
                    preserveScroll: true,
                    onError: (error) => {

                        console.error(error);

                        this.$inertia.message('Problem');

                    },
                    onSuccess: () => {

                        this.$inertia.reload({
                            only: [ 'vacations' ]
                        });

                    }
                }
            );

        },


        reset_to_company_defaults() {

            if ( this.is_company_defaults ) {

                return;

            }


            this.$inertia.delete(
                this.route('notifications.delete_vacations_to_company_default', {
                    is_company_defaults: this.is_company_defaults
                }),
                {
                    preserveScroll: true,
                    onError: (error) => {

                        console.error(error);

                        this.$inertia.message('Problem');

                    },
                    onSuccess: () => {

                        this.$inertia.reload({
                            only: ['vacations']
                        });

                    }
                }
            )

        },

    }

});
</script>

<style scoped>

#vacation_layout{
    grid-template-columns: 200px 80px 200px auto;
}


@media (max-width: 1023px){

    #vacation_layout {
        grid-template-columns: 1fr;
        grid-template-rows: unset!important;
        grid-auto-rows: auto;
    }
}

</style>
